import { BarChart, Briefcase, Gift } from "lucide-react";
import {
  FolderIcon,
  MoneyIcon,
  BookIcon,
  GraduationCapIcon,
  PenIcon,
  BrushPenIcon,
  BracesIcon,
  TerminalIcon,
  WrenchIcon,
  BeakerIcon,
  BrainIcon,
  PopcornIcon,
  ColorPaletteIcon,
  HeartIcon,
  NotebookIcon,
  PlantIcon,
  SnowflakeIcon,
  StethoscopeIcon,
  LotusIcon,
  SuitcaseIcon,
  PlaneIcon,
  GlobeIcon,
  PawIcon,
  DumbBellIcon,
  KettleBellIcon,
  ScalesIcon,
} from "./workspace-icons";

/**
 * Available colors for workspace customization
 * Matches the production ColorIconChooser component
 */
export const WORKSPACE_COLORS = [
  { name: "White", value: "#f8f9fa" },
  { name: "Red", value: "#fa423e" },
  { name: "Orange", value: "#fb6a22" },
  { name: "Yellow", value: "#ffc300" },
  { name: "Green", value: "#04b84c" },
  { name: "Blue", value: "#0285ff" },
  { name: "Purple", value: "#924ff7" },
  { name: "Pink", value: "#ff66ad" },
];

/**
 * Available icons for workspace customization
 * Uses custom SVG icons and lucide-react icons
 */
export const WORKSPACE_ICONS = [
  { name: "Folder", value: "folder", component: FolderIcon },
  { name: "Currency Dollar", value: "money", component: MoneyIcon },
  { name: "Book", value: "book", component: BookIcon },
  { name: "Graduation Cap", value: "education", component: GraduationCapIcon },
  { name: "Pencil", value: "writing", component: PenIcon },
  { name: "Brush Pen", value: "drawing", component: BrushPenIcon },
  { name: "Code Brackets", value: "technology", component: BracesIcon },
  { name: "Terminal", value: "terminal", component: TerminalIcon },
  { name: "Popcorn", value: "entertainment", component: PopcornIcon },
  { name: "Palette", value: "design", component: ColorPaletteIcon },
  { name: "Stethoscope", value: "health", component: StethoscopeIcon },
  { name: "Lotus", value: "spirituality", component: LotusIcon },
  { name: "Briefcase", value: "business", component: Briefcase },
  { name: "Suitcase", value: "travel-bag", component: SuitcaseIcon },
  { name: "Bar Chart", value: "analytics", component: BarChart },
  { name: "Kettlebell", value: "fitness-kettle", component: KettleBellIcon },
  { name: "Dumbbell", value: "fitness", component: DumbBellIcon },
  { name: "Scales", value: "balance", component: ScalesIcon },
  { name: "Globe", value: "research", component: GlobeIcon },
  { name: "Plane", value: "travel", component: PlaneIcon },
  { name: "Wrench", value: "tools", component: WrenchIcon },
  { name: "Paw", value: "pets", component: PawIcon },
  { name: "Flask", value: "science", component: BeakerIcon },
  { name: "Brain", value: "ai", component: BrainIcon },
  { name: "Heart", value: "wellness", component: HeartIcon },
  { name: "Plant", value: "nature", component: PlantIcon },
  { name: "Notebook", value: "notes", component: NotebookIcon },
  { name: "Gift", value: "gifts", component: Gift },
  { name: "Snowflake", value: "winter", component: SnowflakeIcon },
];

/**
 * Get the icon component for a given icon value
 * @param {string} iconValue - The icon value (e.g., "folder", "book")
 * @returns {React.ComponentType} - The icon component, defaults to FolderIcon
 */
export const getWorkspaceIconComponent = (iconValue) => {
  const icon = WORKSPACE_ICONS.find((i) => i.value === iconValue);
  return icon ? icon.component : FolderIcon;
};

/**
 * Get the default workspace color
 * @returns {string} - The default color hex value
 */
export const getDefaultWorkspaceColor = () => WORKSPACE_COLORS[0].value;

/**
 * Get the default workspace icon
 * @returns {string} - The default icon value
 */
export const getDefaultWorkspaceIcon = () => WORKSPACE_ICONS[0].value;
